// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/services/web/user.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  CompanyDetails,
  CompanyUserDetails,
  EnterpriseOrganization,
  OrganizationUserDetails,
  User,
  UserCompanyInvite,
} from "../../types/company";
import { FeatureFlags, PublicGlobalConfig } from "../../types/config";
import {
  CompanyLimits,
  EnterpriseSubscriptionDetails,
  SubscriptionDetails,
  UserLimits,
  UserPlan,
  UserUsageSummary,
} from "../../types/usage";
import { UserInfo, UserPreferences, UserTrialInfo } from "../../types/user";

export const protobufPackage = "api.devplan.services.web.user";

export interface OwnInfo {
  user: User | undefined;
  companyDetails: CompanyDetails[];
  companyUserDetails: CompanyUserDetails[];
  invites: UserCompanyInvite[];
  limits: UserLimits | undefined;
  trialInfo?: UserTrialInfo | undefined;
  ownOrgDetails: OrganizationUserDetails[];
  organizations: EnterpriseOrganization[];
  companyLimits: { [key: number]: CompanyLimits };
}

export interface OwnInfo_CompanyLimitsEntry {
  key: number;
  value: CompanyLimits | undefined;
}

export interface GetSelfResponse {
  ownInfo: OwnInfo | undefined;
}

export interface GetUsageSummaryResponse {
  summary: UserUsageSummary | undefined;
}

export interface UpdateUserRequest {
  user: User | undefined;
}

export interface UpdateUserResponse {
  user: User | undefined;
}

export interface GetOwnCompanyInvitesResponse {
  invites: UserCompanyInvite[];
}

export interface ProcessCompanyInviteRequest {
  accept: boolean;
  inviteId: string;
}

export interface ProcessCompanyInviteResponse {
  ownInfo: OwnInfo | undefined;
}

export interface LeaveCompanyResponse {
  ownInfo: OwnInfo | undefined;
}

export interface GetOwnLimitsResponse {
  limits: UserLimits | undefined;
  companyLimits: { [key: number]: CompanyLimits };
}

export interface GetOwnLimitsResponse_CompanyLimitsEntry {
  key: number;
  value: CompanyLimits | undefined;
}

export interface CreateApiKeyRequest {
  name: string;
}

export interface CreateApiKeyResponse {
  requestId: string;
}

export interface CheckApiKeyRequest {
  requestId: string;
}

export interface CheckApiKeyResponse {
  status: { $case: "pendingMessage"; value: string } | { $case: "apiKey"; value: string } | undefined;
}

export interface GetFeatureFlagsResponse {
  featureFlags: FeatureFlags | undefined;
}

export interface GetUserPreferencesResponse {
  preferences: UserPreferences | undefined;
}

export interface UpdateUserPreferencesRequest {
  preferences: UserPreferences | undefined;
}

export interface UpdateUserPreferencesResponse {
  preferences: UserPreferences | undefined;
}

export interface GetUserPlansResponse {
  plans: UserPlan[];
}

export interface UpdateUserInfoRequest {
  info: UserInfo | undefined;
}

export interface UpdateUserInfoResponse {
  info: UserInfo | undefined;
}

export interface GetUserInfoResponse {
  info?: UserInfo | undefined;
}

export interface GetSubscriptionResponse {
  subscription?: SubscriptionDetails | undefined;
  enterpriseSubscriptions: EnterpriseSubscriptionDetails[];
}

export interface StartSubscriptionRequest {
  priceId: string;
  tierId: string;
}

export interface StartSubscriptionResponse {
  sessionUrl: string;
}

export interface StartEnterpriseSubscriptionRequest {
  priceId: string;
  tierId: string;
  orgId: string;
}

export interface StartEnterpriseSubscriptionResponse {
  sessionUrl: string;
}

export interface GetPublicGlobalConfigResponse {
  config: PublicGlobalConfig | undefined;
}

function createBaseOwnInfo(): OwnInfo {
  return {
    user: undefined,
    companyDetails: [],
    companyUserDetails: [],
    invites: [],
    limits: undefined,
    trialInfo: undefined,
    ownOrgDetails: [],
    organizations: [],
    companyLimits: {},
  };
}

export const OwnInfo: MessageFns<OwnInfo> = {
  encode(message: OwnInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(10).fork()).join();
    }
    for (const v of message.companyDetails) {
      CompanyDetails.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.companyUserDetails) {
      CompanyUserDetails.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.invites) {
      UserCompanyInvite.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.limits !== undefined) {
      UserLimits.encode(message.limits, writer.uint32(42).fork()).join();
    }
    if (message.trialInfo !== undefined) {
      UserTrialInfo.encode(message.trialInfo, writer.uint32(50).fork()).join();
    }
    for (const v of message.ownOrgDetails) {
      OrganizationUserDetails.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.organizations) {
      EnterpriseOrganization.encode(v!, writer.uint32(66).fork()).join();
    }
    globalThis.Object.entries(message.companyLimits).forEach(([key, value]: [string, CompanyLimits]) => {
      OwnInfo_CompanyLimitsEntry.encode({ key: key as any, value }, writer.uint32(74).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OwnInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOwnInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.user = User.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.companyDetails.push(CompanyDetails.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.companyUserDetails.push(CompanyUserDetails.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.invites.push(UserCompanyInvite.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.limits = UserLimits.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.trialInfo = UserTrialInfo.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.ownOrgDetails.push(OrganizationUserDetails.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.organizations.push(EnterpriseOrganization.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          const entry9 = OwnInfo_CompanyLimitsEntry.decode(reader, reader.uint32());
          if (entry9.value !== undefined) {
            message.companyLimits[entry9.key] = entry9.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OwnInfo {
    return {
      user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
      companyDetails: globalThis.Array.isArray(object?.companyDetails)
        ? object.companyDetails.map((e: any) => CompanyDetails.fromJSON(e))
        : globalThis.Array.isArray(object?.company_details)
        ? object.company_details.map((e: any) => CompanyDetails.fromJSON(e))
        : [],
      companyUserDetails: globalThis.Array.isArray(object?.companyUserDetails)
        ? object.companyUserDetails.map((e: any) => CompanyUserDetails.fromJSON(e))
        : globalThis.Array.isArray(object?.company_user_details)
        ? object.company_user_details.map((e: any) => CompanyUserDetails.fromJSON(e))
        : [],
      invites: globalThis.Array.isArray(object?.invites)
        ? object.invites.map((e: any) => UserCompanyInvite.fromJSON(e))
        : [],
      limits: isSet(object.limits) ? UserLimits.fromJSON(object.limits) : undefined,
      trialInfo: isSet(object.trialInfo)
        ? UserTrialInfo.fromJSON(object.trialInfo)
        : isSet(object.trial_info)
        ? UserTrialInfo.fromJSON(object.trial_info)
        : undefined,
      ownOrgDetails: globalThis.Array.isArray(object?.ownOrgDetails)
        ? object.ownOrgDetails.map((e: any) => OrganizationUserDetails.fromJSON(e))
        : globalThis.Array.isArray(object?.own_org_details)
        ? object.own_org_details.map((e: any) => OrganizationUserDetails.fromJSON(e))
        : [],
      organizations: globalThis.Array.isArray(object?.organizations)
        ? object.organizations.map((e: any) => EnterpriseOrganization.fromJSON(e))
        : [],
      companyLimits: isObject(object.companyLimits)
        ? (globalThis.Object.entries(object.companyLimits) as [string, any][]).reduce(
          (acc: { [key: number]: CompanyLimits }, [key, value]: [string, any]) => {
            acc[globalThis.Number(key)] = CompanyLimits.fromJSON(value);
            return acc;
          },
          {},
        )
        : isObject(object.company_limits)
        ? (globalThis.Object.entries(object.company_limits) as [string, any][]).reduce(
          (acc: { [key: number]: CompanyLimits }, [key, value]: [string, any]) => {
            acc[globalThis.Number(key)] = CompanyLimits.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: OwnInfo): unknown {
    const obj: any = {};
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user);
    }
    if (message.companyDetails?.length) {
      obj.companyDetails = message.companyDetails.map((e) => CompanyDetails.toJSON(e));
    }
    if (message.companyUserDetails?.length) {
      obj.companyUserDetails = message.companyUserDetails.map((e) => CompanyUserDetails.toJSON(e));
    }
    if (message.invites?.length) {
      obj.invites = message.invites.map((e) => UserCompanyInvite.toJSON(e));
    }
    if (message.limits !== undefined) {
      obj.limits = UserLimits.toJSON(message.limits);
    }
    if (message.trialInfo !== undefined) {
      obj.trialInfo = UserTrialInfo.toJSON(message.trialInfo);
    }
    if (message.ownOrgDetails?.length) {
      obj.ownOrgDetails = message.ownOrgDetails.map((e) => OrganizationUserDetails.toJSON(e));
    }
    if (message.organizations?.length) {
      obj.organizations = message.organizations.map((e) => EnterpriseOrganization.toJSON(e));
    }
    if (message.companyLimits) {
      const entries = globalThis.Object.entries(message.companyLimits) as [string, CompanyLimits][];
      if (entries.length > 0) {
        obj.companyLimits = {};
        entries.forEach(([k, v]) => {
          obj.companyLimits[k] = CompanyLimits.toJSON(v);
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<OwnInfo>): OwnInfo {
    return OwnInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<OwnInfo>): OwnInfo {
    const message = createBaseOwnInfo();
    message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
    message.companyDetails = object.companyDetails?.map((e) => CompanyDetails.fromPartial(e)) || [];
    message.companyUserDetails = object.companyUserDetails?.map((e) => CompanyUserDetails.fromPartial(e)) || [];
    message.invites = object.invites?.map((e) => UserCompanyInvite.fromPartial(e)) || [];
    message.limits = (object.limits !== undefined && object.limits !== null)
      ? UserLimits.fromPartial(object.limits)
      : undefined;
    message.trialInfo = (object.trialInfo !== undefined && object.trialInfo !== null)
      ? UserTrialInfo.fromPartial(object.trialInfo)
      : undefined;
    message.ownOrgDetails = object.ownOrgDetails?.map((e) => OrganizationUserDetails.fromPartial(e)) || [];
    message.organizations = object.organizations?.map((e) => EnterpriseOrganization.fromPartial(e)) || [];
    message.companyLimits = (globalThis.Object.entries(object.companyLimits ?? {}) as [string, CompanyLimits][]).reduce(
      (acc: { [key: number]: CompanyLimits }, [key, value]: [string, CompanyLimits]) => {
        if (value !== undefined) {
          acc[globalThis.Number(key)] = CompanyLimits.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseOwnInfo_CompanyLimitsEntry(): OwnInfo_CompanyLimitsEntry {
  return { key: 0, value: undefined };
}

export const OwnInfo_CompanyLimitsEntry: MessageFns<OwnInfo_CompanyLimitsEntry> = {
  encode(message: OwnInfo_CompanyLimitsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== 0) {
      writer.uint32(8).int32(message.key);
    }
    if (message.value !== undefined) {
      CompanyLimits.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OwnInfo_CompanyLimitsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOwnInfo_CompanyLimitsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.key = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = CompanyLimits.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OwnInfo_CompanyLimitsEntry {
    return {
      key: isSet(object.key) ? globalThis.Number(object.key) : 0,
      value: isSet(object.value) ? CompanyLimits.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: OwnInfo_CompanyLimitsEntry): unknown {
    const obj: any = {};
    if (message.key !== 0) {
      obj.key = Math.round(message.key);
    }
    if (message.value !== undefined) {
      obj.value = CompanyLimits.toJSON(message.value);
    }
    return obj;
  },

  create(base?: DeepPartial<OwnInfo_CompanyLimitsEntry>): OwnInfo_CompanyLimitsEntry {
    return OwnInfo_CompanyLimitsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<OwnInfo_CompanyLimitsEntry>): OwnInfo_CompanyLimitsEntry {
    const message = createBaseOwnInfo_CompanyLimitsEntry();
    message.key = object.key ?? 0;
    message.value = (object.value !== undefined && object.value !== null)
      ? CompanyLimits.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseGetSelfResponse(): GetSelfResponse {
  return { ownInfo: undefined };
}

export const GetSelfResponse: MessageFns<GetSelfResponse> = {
  encode(message: GetSelfResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ownInfo !== undefined) {
      OwnInfo.encode(message.ownInfo, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSelfResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSelfResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ownInfo = OwnInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSelfResponse {
    return {
      ownInfo: isSet(object.ownInfo)
        ? OwnInfo.fromJSON(object.ownInfo)
        : isSet(object.own_info)
        ? OwnInfo.fromJSON(object.own_info)
        : undefined,
    };
  },

  toJSON(message: GetSelfResponse): unknown {
    const obj: any = {};
    if (message.ownInfo !== undefined) {
      obj.ownInfo = OwnInfo.toJSON(message.ownInfo);
    }
    return obj;
  },

  create(base?: DeepPartial<GetSelfResponse>): GetSelfResponse {
    return GetSelfResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetSelfResponse>): GetSelfResponse {
    const message = createBaseGetSelfResponse();
    message.ownInfo = (object.ownInfo !== undefined && object.ownInfo !== null)
      ? OwnInfo.fromPartial(object.ownInfo)
      : undefined;
    return message;
  },
};

function createBaseGetUsageSummaryResponse(): GetUsageSummaryResponse {
  return { summary: undefined };
}

export const GetUsageSummaryResponse: MessageFns<GetUsageSummaryResponse> = {
  encode(message: GetUsageSummaryResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.summary !== undefined) {
      UserUsageSummary.encode(message.summary, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetUsageSummaryResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetUsageSummaryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.summary = UserUsageSummary.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetUsageSummaryResponse {
    return { summary: isSet(object.summary) ? UserUsageSummary.fromJSON(object.summary) : undefined };
  },

  toJSON(message: GetUsageSummaryResponse): unknown {
    const obj: any = {};
    if (message.summary !== undefined) {
      obj.summary = UserUsageSummary.toJSON(message.summary);
    }
    return obj;
  },

  create(base?: DeepPartial<GetUsageSummaryResponse>): GetUsageSummaryResponse {
    return GetUsageSummaryResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetUsageSummaryResponse>): GetUsageSummaryResponse {
    const message = createBaseGetUsageSummaryResponse();
    message.summary = (object.summary !== undefined && object.summary !== null)
      ? UserUsageSummary.fromPartial(object.summary)
      : undefined;
    return message;
  },
};

function createBaseUpdateUserRequest(): UpdateUserRequest {
  return { user: undefined };
}

export const UpdateUserRequest: MessageFns<UpdateUserRequest> = {
  encode(message: UpdateUserRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateUserRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateUserRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.user = User.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateUserRequest {
    return { user: isSet(object.user) ? User.fromJSON(object.user) : undefined };
  },

  toJSON(message: UpdateUserRequest): unknown {
    const obj: any = {};
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateUserRequest>): UpdateUserRequest {
    return UpdateUserRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateUserRequest>): UpdateUserRequest {
    const message = createBaseUpdateUserRequest();
    message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
    return message;
  },
};

function createBaseUpdateUserResponse(): UpdateUserResponse {
  return { user: undefined };
}

export const UpdateUserResponse: MessageFns<UpdateUserResponse> = {
  encode(message: UpdateUserResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateUserResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateUserResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.user = User.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateUserResponse {
    return { user: isSet(object.user) ? User.fromJSON(object.user) : undefined };
  },

  toJSON(message: UpdateUserResponse): unknown {
    const obj: any = {};
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateUserResponse>): UpdateUserResponse {
    return UpdateUserResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateUserResponse>): UpdateUserResponse {
    const message = createBaseUpdateUserResponse();
    message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
    return message;
  },
};

function createBaseGetOwnCompanyInvitesResponse(): GetOwnCompanyInvitesResponse {
  return { invites: [] };
}

export const GetOwnCompanyInvitesResponse: MessageFns<GetOwnCompanyInvitesResponse> = {
  encode(message: GetOwnCompanyInvitesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.invites) {
      UserCompanyInvite.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOwnCompanyInvitesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOwnCompanyInvitesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.invites.push(UserCompanyInvite.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOwnCompanyInvitesResponse {
    return {
      invites: globalThis.Array.isArray(object?.invites)
        ? object.invites.map((e: any) => UserCompanyInvite.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetOwnCompanyInvitesResponse): unknown {
    const obj: any = {};
    if (message.invites?.length) {
      obj.invites = message.invites.map((e) => UserCompanyInvite.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetOwnCompanyInvitesResponse>): GetOwnCompanyInvitesResponse {
    return GetOwnCompanyInvitesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetOwnCompanyInvitesResponse>): GetOwnCompanyInvitesResponse {
    const message = createBaseGetOwnCompanyInvitesResponse();
    message.invites = object.invites?.map((e) => UserCompanyInvite.fromPartial(e)) || [];
    return message;
  },
};

function createBaseProcessCompanyInviteRequest(): ProcessCompanyInviteRequest {
  return { accept: false, inviteId: "" };
}

export const ProcessCompanyInviteRequest: MessageFns<ProcessCompanyInviteRequest> = {
  encode(message: ProcessCompanyInviteRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accept !== false) {
      writer.uint32(8).bool(message.accept);
    }
    if (message.inviteId !== "") {
      writer.uint32(18).string(message.inviteId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProcessCompanyInviteRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProcessCompanyInviteRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.accept = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.inviteId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProcessCompanyInviteRequest {
    return {
      accept: isSet(object.accept) ? globalThis.Boolean(object.accept) : false,
      inviteId: isSet(object.inviteId)
        ? globalThis.String(object.inviteId)
        : isSet(object.invite_id)
        ? globalThis.String(object.invite_id)
        : "",
    };
  },

  toJSON(message: ProcessCompanyInviteRequest): unknown {
    const obj: any = {};
    if (message.accept !== false) {
      obj.accept = message.accept;
    }
    if (message.inviteId !== "") {
      obj.inviteId = message.inviteId;
    }
    return obj;
  },

  create(base?: DeepPartial<ProcessCompanyInviteRequest>): ProcessCompanyInviteRequest {
    return ProcessCompanyInviteRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProcessCompanyInviteRequest>): ProcessCompanyInviteRequest {
    const message = createBaseProcessCompanyInviteRequest();
    message.accept = object.accept ?? false;
    message.inviteId = object.inviteId ?? "";
    return message;
  },
};

function createBaseProcessCompanyInviteResponse(): ProcessCompanyInviteResponse {
  return { ownInfo: undefined };
}

export const ProcessCompanyInviteResponse: MessageFns<ProcessCompanyInviteResponse> = {
  encode(message: ProcessCompanyInviteResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ownInfo !== undefined) {
      OwnInfo.encode(message.ownInfo, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProcessCompanyInviteResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProcessCompanyInviteResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ownInfo = OwnInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProcessCompanyInviteResponse {
    return {
      ownInfo: isSet(object.ownInfo)
        ? OwnInfo.fromJSON(object.ownInfo)
        : isSet(object.own_info)
        ? OwnInfo.fromJSON(object.own_info)
        : undefined,
    };
  },

  toJSON(message: ProcessCompanyInviteResponse): unknown {
    const obj: any = {};
    if (message.ownInfo !== undefined) {
      obj.ownInfo = OwnInfo.toJSON(message.ownInfo);
    }
    return obj;
  },

  create(base?: DeepPartial<ProcessCompanyInviteResponse>): ProcessCompanyInviteResponse {
    return ProcessCompanyInviteResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProcessCompanyInviteResponse>): ProcessCompanyInviteResponse {
    const message = createBaseProcessCompanyInviteResponse();
    message.ownInfo = (object.ownInfo !== undefined && object.ownInfo !== null)
      ? OwnInfo.fromPartial(object.ownInfo)
      : undefined;
    return message;
  },
};

function createBaseLeaveCompanyResponse(): LeaveCompanyResponse {
  return { ownInfo: undefined };
}

export const LeaveCompanyResponse: MessageFns<LeaveCompanyResponse> = {
  encode(message: LeaveCompanyResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ownInfo !== undefined) {
      OwnInfo.encode(message.ownInfo, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LeaveCompanyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLeaveCompanyResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ownInfo = OwnInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LeaveCompanyResponse {
    return {
      ownInfo: isSet(object.ownInfo)
        ? OwnInfo.fromJSON(object.ownInfo)
        : isSet(object.own_info)
        ? OwnInfo.fromJSON(object.own_info)
        : undefined,
    };
  },

  toJSON(message: LeaveCompanyResponse): unknown {
    const obj: any = {};
    if (message.ownInfo !== undefined) {
      obj.ownInfo = OwnInfo.toJSON(message.ownInfo);
    }
    return obj;
  },

  create(base?: DeepPartial<LeaveCompanyResponse>): LeaveCompanyResponse {
    return LeaveCompanyResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LeaveCompanyResponse>): LeaveCompanyResponse {
    const message = createBaseLeaveCompanyResponse();
    message.ownInfo = (object.ownInfo !== undefined && object.ownInfo !== null)
      ? OwnInfo.fromPartial(object.ownInfo)
      : undefined;
    return message;
  },
};

function createBaseGetOwnLimitsResponse(): GetOwnLimitsResponse {
  return { limits: undefined, companyLimits: {} };
}

export const GetOwnLimitsResponse: MessageFns<GetOwnLimitsResponse> = {
  encode(message: GetOwnLimitsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.limits !== undefined) {
      UserLimits.encode(message.limits, writer.uint32(10).fork()).join();
    }
    globalThis.Object.entries(message.companyLimits).forEach(([key, value]: [string, CompanyLimits]) => {
      GetOwnLimitsResponse_CompanyLimitsEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOwnLimitsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOwnLimitsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.limits = UserLimits.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = GetOwnLimitsResponse_CompanyLimitsEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.companyLimits[entry2.key] = entry2.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOwnLimitsResponse {
    return {
      limits: isSet(object.limits) ? UserLimits.fromJSON(object.limits) : undefined,
      companyLimits: isObject(object.companyLimits)
        ? (globalThis.Object.entries(object.companyLimits) as [string, any][]).reduce(
          (acc: { [key: number]: CompanyLimits }, [key, value]: [string, any]) => {
            acc[globalThis.Number(key)] = CompanyLimits.fromJSON(value);
            return acc;
          },
          {},
        )
        : isObject(object.company_limits)
        ? (globalThis.Object.entries(object.company_limits) as [string, any][]).reduce(
          (acc: { [key: number]: CompanyLimits }, [key, value]: [string, any]) => {
            acc[globalThis.Number(key)] = CompanyLimits.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: GetOwnLimitsResponse): unknown {
    const obj: any = {};
    if (message.limits !== undefined) {
      obj.limits = UserLimits.toJSON(message.limits);
    }
    if (message.companyLimits) {
      const entries = globalThis.Object.entries(message.companyLimits) as [string, CompanyLimits][];
      if (entries.length > 0) {
        obj.companyLimits = {};
        entries.forEach(([k, v]) => {
          obj.companyLimits[k] = CompanyLimits.toJSON(v);
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<GetOwnLimitsResponse>): GetOwnLimitsResponse {
    return GetOwnLimitsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetOwnLimitsResponse>): GetOwnLimitsResponse {
    const message = createBaseGetOwnLimitsResponse();
    message.limits = (object.limits !== undefined && object.limits !== null)
      ? UserLimits.fromPartial(object.limits)
      : undefined;
    message.companyLimits = (globalThis.Object.entries(object.companyLimits ?? {}) as [string, CompanyLimits][]).reduce(
      (acc: { [key: number]: CompanyLimits }, [key, value]: [string, CompanyLimits]) => {
        if (value !== undefined) {
          acc[globalThis.Number(key)] = CompanyLimits.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseGetOwnLimitsResponse_CompanyLimitsEntry(): GetOwnLimitsResponse_CompanyLimitsEntry {
  return { key: 0, value: undefined };
}

export const GetOwnLimitsResponse_CompanyLimitsEntry: MessageFns<GetOwnLimitsResponse_CompanyLimitsEntry> = {
  encode(message: GetOwnLimitsResponse_CompanyLimitsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== 0) {
      writer.uint32(8).int32(message.key);
    }
    if (message.value !== undefined) {
      CompanyLimits.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOwnLimitsResponse_CompanyLimitsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOwnLimitsResponse_CompanyLimitsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.key = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = CompanyLimits.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOwnLimitsResponse_CompanyLimitsEntry {
    return {
      key: isSet(object.key) ? globalThis.Number(object.key) : 0,
      value: isSet(object.value) ? CompanyLimits.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: GetOwnLimitsResponse_CompanyLimitsEntry): unknown {
    const obj: any = {};
    if (message.key !== 0) {
      obj.key = Math.round(message.key);
    }
    if (message.value !== undefined) {
      obj.value = CompanyLimits.toJSON(message.value);
    }
    return obj;
  },

  create(base?: DeepPartial<GetOwnLimitsResponse_CompanyLimitsEntry>): GetOwnLimitsResponse_CompanyLimitsEntry {
    return GetOwnLimitsResponse_CompanyLimitsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetOwnLimitsResponse_CompanyLimitsEntry>): GetOwnLimitsResponse_CompanyLimitsEntry {
    const message = createBaseGetOwnLimitsResponse_CompanyLimitsEntry();
    message.key = object.key ?? 0;
    message.value = (object.value !== undefined && object.value !== null)
      ? CompanyLimits.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseCreateApiKeyRequest(): CreateApiKeyRequest {
  return { name: "" };
}

export const CreateApiKeyRequest: MessageFns<CreateApiKeyRequest> = {
  encode(message: CreateApiKeyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateApiKeyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateApiKeyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateApiKeyRequest {
    return { name: isSet(object.name) ? globalThis.String(object.name) : "" };
  },

  toJSON(message: CreateApiKeyRequest): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create(base?: DeepPartial<CreateApiKeyRequest>): CreateApiKeyRequest {
    return CreateApiKeyRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateApiKeyRequest>): CreateApiKeyRequest {
    const message = createBaseCreateApiKeyRequest();
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseCreateApiKeyResponse(): CreateApiKeyResponse {
  return { requestId: "" };
}

export const CreateApiKeyResponse: MessageFns<CreateApiKeyResponse> = {
  encode(message: CreateApiKeyResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.requestId !== "") {
      writer.uint32(10).string(message.requestId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateApiKeyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateApiKeyResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.requestId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateApiKeyResponse {
    return {
      requestId: isSet(object.requestId)
        ? globalThis.String(object.requestId)
        : isSet(object.request_id)
        ? globalThis.String(object.request_id)
        : "",
    };
  },

  toJSON(message: CreateApiKeyResponse): unknown {
    const obj: any = {};
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    return obj;
  },

  create(base?: DeepPartial<CreateApiKeyResponse>): CreateApiKeyResponse {
    return CreateApiKeyResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateApiKeyResponse>): CreateApiKeyResponse {
    const message = createBaseCreateApiKeyResponse();
    message.requestId = object.requestId ?? "";
    return message;
  },
};

function createBaseCheckApiKeyRequest(): CheckApiKeyRequest {
  return { requestId: "" };
}

export const CheckApiKeyRequest: MessageFns<CheckApiKeyRequest> = {
  encode(message: CheckApiKeyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.requestId !== "") {
      writer.uint32(10).string(message.requestId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CheckApiKeyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCheckApiKeyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.requestId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CheckApiKeyRequest {
    return {
      requestId: isSet(object.requestId)
        ? globalThis.String(object.requestId)
        : isSet(object.request_id)
        ? globalThis.String(object.request_id)
        : "",
    };
  },

  toJSON(message: CheckApiKeyRequest): unknown {
    const obj: any = {};
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    return obj;
  },

  create(base?: DeepPartial<CheckApiKeyRequest>): CheckApiKeyRequest {
    return CheckApiKeyRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CheckApiKeyRequest>): CheckApiKeyRequest {
    const message = createBaseCheckApiKeyRequest();
    message.requestId = object.requestId ?? "";
    return message;
  },
};

function createBaseCheckApiKeyResponse(): CheckApiKeyResponse {
  return { status: undefined };
}

export const CheckApiKeyResponse: MessageFns<CheckApiKeyResponse> = {
  encode(message: CheckApiKeyResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.status?.$case) {
      case "pendingMessage":
        writer.uint32(802).string(message.status.value);
        break;
      case "apiKey":
        writer.uint32(810).string(message.status.value);
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CheckApiKeyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCheckApiKeyResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.status = { $case: "pendingMessage", value: reader.string() };
          continue;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.status = { $case: "apiKey", value: reader.string() };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CheckApiKeyResponse {
    return {
      status: isSet(object.pendingMessage)
        ? { $case: "pendingMessage", value: globalThis.String(object.pendingMessage) }
        : isSet(object.pending_message)
        ? { $case: "pendingMessage", value: globalThis.String(object.pending_message) }
        : isSet(object.apiKey)
        ? { $case: "apiKey", value: globalThis.String(object.apiKey) }
        : isSet(object.api_key)
        ? { $case: "apiKey", value: globalThis.String(object.api_key) }
        : undefined,
    };
  },

  toJSON(message: CheckApiKeyResponse): unknown {
    const obj: any = {};
    if (message.status?.$case === "pendingMessage") {
      obj.pendingMessage = message.status.value;
    } else if (message.status?.$case === "apiKey") {
      obj.apiKey = message.status.value;
    }
    return obj;
  },

  create(base?: DeepPartial<CheckApiKeyResponse>): CheckApiKeyResponse {
    return CheckApiKeyResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CheckApiKeyResponse>): CheckApiKeyResponse {
    const message = createBaseCheckApiKeyResponse();
    switch (object.status?.$case) {
      case "pendingMessage": {
        if (object.status?.value !== undefined && object.status?.value !== null) {
          message.status = { $case: "pendingMessage", value: object.status.value };
        }
        break;
      }
      case "apiKey": {
        if (object.status?.value !== undefined && object.status?.value !== null) {
          message.status = { $case: "apiKey", value: object.status.value };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseGetFeatureFlagsResponse(): GetFeatureFlagsResponse {
  return { featureFlags: undefined };
}

export const GetFeatureFlagsResponse: MessageFns<GetFeatureFlagsResponse> = {
  encode(message: GetFeatureFlagsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.featureFlags !== undefined) {
      FeatureFlags.encode(message.featureFlags, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFeatureFlagsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFeatureFlagsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.featureFlags = FeatureFlags.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFeatureFlagsResponse {
    return {
      featureFlags: isSet(object.featureFlags)
        ? FeatureFlags.fromJSON(object.featureFlags)
        : isSet(object.feature_flags)
        ? FeatureFlags.fromJSON(object.feature_flags)
        : undefined,
    };
  },

  toJSON(message: GetFeatureFlagsResponse): unknown {
    const obj: any = {};
    if (message.featureFlags !== undefined) {
      obj.featureFlags = FeatureFlags.toJSON(message.featureFlags);
    }
    return obj;
  },

  create(base?: DeepPartial<GetFeatureFlagsResponse>): GetFeatureFlagsResponse {
    return GetFeatureFlagsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetFeatureFlagsResponse>): GetFeatureFlagsResponse {
    const message = createBaseGetFeatureFlagsResponse();
    message.featureFlags = (object.featureFlags !== undefined && object.featureFlags !== null)
      ? FeatureFlags.fromPartial(object.featureFlags)
      : undefined;
    return message;
  },
};

function createBaseGetUserPreferencesResponse(): GetUserPreferencesResponse {
  return { preferences: undefined };
}

export const GetUserPreferencesResponse: MessageFns<GetUserPreferencesResponse> = {
  encode(message: GetUserPreferencesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.preferences !== undefined) {
      UserPreferences.encode(message.preferences, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetUserPreferencesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetUserPreferencesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.preferences = UserPreferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetUserPreferencesResponse {
    return { preferences: isSet(object.preferences) ? UserPreferences.fromJSON(object.preferences) : undefined };
  },

  toJSON(message: GetUserPreferencesResponse): unknown {
    const obj: any = {};
    if (message.preferences !== undefined) {
      obj.preferences = UserPreferences.toJSON(message.preferences);
    }
    return obj;
  },

  create(base?: DeepPartial<GetUserPreferencesResponse>): GetUserPreferencesResponse {
    return GetUserPreferencesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetUserPreferencesResponse>): GetUserPreferencesResponse {
    const message = createBaseGetUserPreferencesResponse();
    message.preferences = (object.preferences !== undefined && object.preferences !== null)
      ? UserPreferences.fromPartial(object.preferences)
      : undefined;
    return message;
  },
};

function createBaseUpdateUserPreferencesRequest(): UpdateUserPreferencesRequest {
  return { preferences: undefined };
}

export const UpdateUserPreferencesRequest: MessageFns<UpdateUserPreferencesRequest> = {
  encode(message: UpdateUserPreferencesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.preferences !== undefined) {
      UserPreferences.encode(message.preferences, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateUserPreferencesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateUserPreferencesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.preferences = UserPreferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateUserPreferencesRequest {
    return { preferences: isSet(object.preferences) ? UserPreferences.fromJSON(object.preferences) : undefined };
  },

  toJSON(message: UpdateUserPreferencesRequest): unknown {
    const obj: any = {};
    if (message.preferences !== undefined) {
      obj.preferences = UserPreferences.toJSON(message.preferences);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateUserPreferencesRequest>): UpdateUserPreferencesRequest {
    return UpdateUserPreferencesRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateUserPreferencesRequest>): UpdateUserPreferencesRequest {
    const message = createBaseUpdateUserPreferencesRequest();
    message.preferences = (object.preferences !== undefined && object.preferences !== null)
      ? UserPreferences.fromPartial(object.preferences)
      : undefined;
    return message;
  },
};

function createBaseUpdateUserPreferencesResponse(): UpdateUserPreferencesResponse {
  return { preferences: undefined };
}

export const UpdateUserPreferencesResponse: MessageFns<UpdateUserPreferencesResponse> = {
  encode(message: UpdateUserPreferencesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.preferences !== undefined) {
      UserPreferences.encode(message.preferences, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateUserPreferencesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateUserPreferencesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.preferences = UserPreferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateUserPreferencesResponse {
    return { preferences: isSet(object.preferences) ? UserPreferences.fromJSON(object.preferences) : undefined };
  },

  toJSON(message: UpdateUserPreferencesResponse): unknown {
    const obj: any = {};
    if (message.preferences !== undefined) {
      obj.preferences = UserPreferences.toJSON(message.preferences);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateUserPreferencesResponse>): UpdateUserPreferencesResponse {
    return UpdateUserPreferencesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateUserPreferencesResponse>): UpdateUserPreferencesResponse {
    const message = createBaseUpdateUserPreferencesResponse();
    message.preferences = (object.preferences !== undefined && object.preferences !== null)
      ? UserPreferences.fromPartial(object.preferences)
      : undefined;
    return message;
  },
};

function createBaseGetUserPlansResponse(): GetUserPlansResponse {
  return { plans: [] };
}

export const GetUserPlansResponse: MessageFns<GetUserPlansResponse> = {
  encode(message: GetUserPlansResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.plans) {
      UserPlan.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetUserPlansResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetUserPlansResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.plans.push(UserPlan.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetUserPlansResponse {
    return { plans: globalThis.Array.isArray(object?.plans) ? object.plans.map((e: any) => UserPlan.fromJSON(e)) : [] };
  },

  toJSON(message: GetUserPlansResponse): unknown {
    const obj: any = {};
    if (message.plans?.length) {
      obj.plans = message.plans.map((e) => UserPlan.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetUserPlansResponse>): GetUserPlansResponse {
    return GetUserPlansResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetUserPlansResponse>): GetUserPlansResponse {
    const message = createBaseGetUserPlansResponse();
    message.plans = object.plans?.map((e) => UserPlan.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateUserInfoRequest(): UpdateUserInfoRequest {
  return { info: undefined };
}

export const UpdateUserInfoRequest: MessageFns<UpdateUserInfoRequest> = {
  encode(message: UpdateUserInfoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.info !== undefined) {
      UserInfo.encode(message.info, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateUserInfoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateUserInfoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.info = UserInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateUserInfoRequest {
    return { info: isSet(object.info) ? UserInfo.fromJSON(object.info) : undefined };
  },

  toJSON(message: UpdateUserInfoRequest): unknown {
    const obj: any = {};
    if (message.info !== undefined) {
      obj.info = UserInfo.toJSON(message.info);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateUserInfoRequest>): UpdateUserInfoRequest {
    return UpdateUserInfoRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateUserInfoRequest>): UpdateUserInfoRequest {
    const message = createBaseUpdateUserInfoRequest();
    message.info = (object.info !== undefined && object.info !== null) ? UserInfo.fromPartial(object.info) : undefined;
    return message;
  },
};

function createBaseUpdateUserInfoResponse(): UpdateUserInfoResponse {
  return { info: undefined };
}

export const UpdateUserInfoResponse: MessageFns<UpdateUserInfoResponse> = {
  encode(message: UpdateUserInfoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.info !== undefined) {
      UserInfo.encode(message.info, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateUserInfoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateUserInfoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.info = UserInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateUserInfoResponse {
    return { info: isSet(object.info) ? UserInfo.fromJSON(object.info) : undefined };
  },

  toJSON(message: UpdateUserInfoResponse): unknown {
    const obj: any = {};
    if (message.info !== undefined) {
      obj.info = UserInfo.toJSON(message.info);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateUserInfoResponse>): UpdateUserInfoResponse {
    return UpdateUserInfoResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateUserInfoResponse>): UpdateUserInfoResponse {
    const message = createBaseUpdateUserInfoResponse();
    message.info = (object.info !== undefined && object.info !== null) ? UserInfo.fromPartial(object.info) : undefined;
    return message;
  },
};

function createBaseGetUserInfoResponse(): GetUserInfoResponse {
  return { info: undefined };
}

export const GetUserInfoResponse: MessageFns<GetUserInfoResponse> = {
  encode(message: GetUserInfoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.info !== undefined) {
      UserInfo.encode(message.info, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetUserInfoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetUserInfoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.info = UserInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetUserInfoResponse {
    return { info: isSet(object.info) ? UserInfo.fromJSON(object.info) : undefined };
  },

  toJSON(message: GetUserInfoResponse): unknown {
    const obj: any = {};
    if (message.info !== undefined) {
      obj.info = UserInfo.toJSON(message.info);
    }
    return obj;
  },

  create(base?: DeepPartial<GetUserInfoResponse>): GetUserInfoResponse {
    return GetUserInfoResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetUserInfoResponse>): GetUserInfoResponse {
    const message = createBaseGetUserInfoResponse();
    message.info = (object.info !== undefined && object.info !== null) ? UserInfo.fromPartial(object.info) : undefined;
    return message;
  },
};

function createBaseGetSubscriptionResponse(): GetSubscriptionResponse {
  return { subscription: undefined, enterpriseSubscriptions: [] };
}

export const GetSubscriptionResponse: MessageFns<GetSubscriptionResponse> = {
  encode(message: GetSubscriptionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.subscription !== undefined) {
      SubscriptionDetails.encode(message.subscription, writer.uint32(10).fork()).join();
    }
    for (const v of message.enterpriseSubscriptions) {
      EnterpriseSubscriptionDetails.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSubscriptionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSubscriptionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.subscription = SubscriptionDetails.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.enterpriseSubscriptions.push(EnterpriseSubscriptionDetails.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSubscriptionResponse {
    return {
      subscription: isSet(object.subscription) ? SubscriptionDetails.fromJSON(object.subscription) : undefined,
      enterpriseSubscriptions: globalThis.Array.isArray(object?.enterpriseSubscriptions)
        ? object.enterpriseSubscriptions.map((e: any) => EnterpriseSubscriptionDetails.fromJSON(e))
        : globalThis.Array.isArray(object?.enterprise_subscriptions)
        ? object.enterprise_subscriptions.map((e: any) => EnterpriseSubscriptionDetails.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetSubscriptionResponse): unknown {
    const obj: any = {};
    if (message.subscription !== undefined) {
      obj.subscription = SubscriptionDetails.toJSON(message.subscription);
    }
    if (message.enterpriseSubscriptions?.length) {
      obj.enterpriseSubscriptions = message.enterpriseSubscriptions.map((e) => EnterpriseSubscriptionDetails.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetSubscriptionResponse>): GetSubscriptionResponse {
    return GetSubscriptionResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetSubscriptionResponse>): GetSubscriptionResponse {
    const message = createBaseGetSubscriptionResponse();
    message.subscription = (object.subscription !== undefined && object.subscription !== null)
      ? SubscriptionDetails.fromPartial(object.subscription)
      : undefined;
    message.enterpriseSubscriptions =
      object.enterpriseSubscriptions?.map((e) => EnterpriseSubscriptionDetails.fromPartial(e)) || [];
    return message;
  },
};

function createBaseStartSubscriptionRequest(): StartSubscriptionRequest {
  return { priceId: "", tierId: "" };
}

export const StartSubscriptionRequest: MessageFns<StartSubscriptionRequest> = {
  encode(message: StartSubscriptionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.priceId !== "") {
      writer.uint32(10).string(message.priceId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartSubscriptionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartSubscriptionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.priceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartSubscriptionRequest {
    return {
      priceId: isSet(object.priceId)
        ? globalThis.String(object.priceId)
        : isSet(object.price_id)
        ? globalThis.String(object.price_id)
        : "",
      tierId: isSet(object.tierId)
        ? globalThis.String(object.tierId)
        : isSet(object.tier_id)
        ? globalThis.String(object.tier_id)
        : "",
    };
  },

  toJSON(message: StartSubscriptionRequest): unknown {
    const obj: any = {};
    if (message.priceId !== "") {
      obj.priceId = message.priceId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    return obj;
  },

  create(base?: DeepPartial<StartSubscriptionRequest>): StartSubscriptionRequest {
    return StartSubscriptionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartSubscriptionRequest>): StartSubscriptionRequest {
    const message = createBaseStartSubscriptionRequest();
    message.priceId = object.priceId ?? "";
    message.tierId = object.tierId ?? "";
    return message;
  },
};

function createBaseStartSubscriptionResponse(): StartSubscriptionResponse {
  return { sessionUrl: "" };
}

export const StartSubscriptionResponse: MessageFns<StartSubscriptionResponse> = {
  encode(message: StartSubscriptionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sessionUrl !== "") {
      writer.uint32(10).string(message.sessionUrl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartSubscriptionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartSubscriptionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sessionUrl = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartSubscriptionResponse {
    return {
      sessionUrl: isSet(object.sessionUrl)
        ? globalThis.String(object.sessionUrl)
        : isSet(object.session_url)
        ? globalThis.String(object.session_url)
        : "",
    };
  },

  toJSON(message: StartSubscriptionResponse): unknown {
    const obj: any = {};
    if (message.sessionUrl !== "") {
      obj.sessionUrl = message.sessionUrl;
    }
    return obj;
  },

  create(base?: DeepPartial<StartSubscriptionResponse>): StartSubscriptionResponse {
    return StartSubscriptionResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartSubscriptionResponse>): StartSubscriptionResponse {
    const message = createBaseStartSubscriptionResponse();
    message.sessionUrl = object.sessionUrl ?? "";
    return message;
  },
};

function createBaseStartEnterpriseSubscriptionRequest(): StartEnterpriseSubscriptionRequest {
  return { priceId: "", tierId: "", orgId: "" };
}

export const StartEnterpriseSubscriptionRequest: MessageFns<StartEnterpriseSubscriptionRequest> = {
  encode(message: StartEnterpriseSubscriptionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.priceId !== "") {
      writer.uint32(10).string(message.priceId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    if (message.orgId !== "") {
      writer.uint32(26).string(message.orgId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartEnterpriseSubscriptionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartEnterpriseSubscriptionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.priceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartEnterpriseSubscriptionRequest {
    return {
      priceId: isSet(object.priceId)
        ? globalThis.String(object.priceId)
        : isSet(object.price_id)
        ? globalThis.String(object.price_id)
        : "",
      tierId: isSet(object.tierId)
        ? globalThis.String(object.tierId)
        : isSet(object.tier_id)
        ? globalThis.String(object.tier_id)
        : "",
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
    };
  },

  toJSON(message: StartEnterpriseSubscriptionRequest): unknown {
    const obj: any = {};
    if (message.priceId !== "") {
      obj.priceId = message.priceId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    return obj;
  },

  create(base?: DeepPartial<StartEnterpriseSubscriptionRequest>): StartEnterpriseSubscriptionRequest {
    return StartEnterpriseSubscriptionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartEnterpriseSubscriptionRequest>): StartEnterpriseSubscriptionRequest {
    const message = createBaseStartEnterpriseSubscriptionRequest();
    message.priceId = object.priceId ?? "";
    message.tierId = object.tierId ?? "";
    message.orgId = object.orgId ?? "";
    return message;
  },
};

function createBaseStartEnterpriseSubscriptionResponse(): StartEnterpriseSubscriptionResponse {
  return { sessionUrl: "" };
}

export const StartEnterpriseSubscriptionResponse: MessageFns<StartEnterpriseSubscriptionResponse> = {
  encode(message: StartEnterpriseSubscriptionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sessionUrl !== "") {
      writer.uint32(10).string(message.sessionUrl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartEnterpriseSubscriptionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartEnterpriseSubscriptionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sessionUrl = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartEnterpriseSubscriptionResponse {
    return {
      sessionUrl: isSet(object.sessionUrl)
        ? globalThis.String(object.sessionUrl)
        : isSet(object.session_url)
        ? globalThis.String(object.session_url)
        : "",
    };
  },

  toJSON(message: StartEnterpriseSubscriptionResponse): unknown {
    const obj: any = {};
    if (message.sessionUrl !== "") {
      obj.sessionUrl = message.sessionUrl;
    }
    return obj;
  },

  create(base?: DeepPartial<StartEnterpriseSubscriptionResponse>): StartEnterpriseSubscriptionResponse {
    return StartEnterpriseSubscriptionResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartEnterpriseSubscriptionResponse>): StartEnterpriseSubscriptionResponse {
    const message = createBaseStartEnterpriseSubscriptionResponse();
    message.sessionUrl = object.sessionUrl ?? "";
    return message;
  },
};

function createBaseGetPublicGlobalConfigResponse(): GetPublicGlobalConfigResponse {
  return { config: undefined };
}

export const GetPublicGlobalConfigResponse: MessageFns<GetPublicGlobalConfigResponse> = {
  encode(message: GetPublicGlobalConfigResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.config !== undefined) {
      PublicGlobalConfig.encode(message.config, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPublicGlobalConfigResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPublicGlobalConfigResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.config = PublicGlobalConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPublicGlobalConfigResponse {
    return { config: isSet(object.config) ? PublicGlobalConfig.fromJSON(object.config) : undefined };
  },

  toJSON(message: GetPublicGlobalConfigResponse): unknown {
    const obj: any = {};
    if (message.config !== undefined) {
      obj.config = PublicGlobalConfig.toJSON(message.config);
    }
    return obj;
  },

  create(base?: DeepPartial<GetPublicGlobalConfigResponse>): GetPublicGlobalConfigResponse {
    return GetPublicGlobalConfigResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetPublicGlobalConfigResponse>): GetPublicGlobalConfigResponse {
    const message = createBaseGetPublicGlobalConfigResponse();
    message.config = (object.config !== undefined && object.config !== null)
      ? PublicGlobalConfig.fromPartial(object.config)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
